import {lazy} from '@aboutyou/lazy-imports';

export const HelpCenterChatbot = lazy(() =>
  import('./HelpCenterChatbot.eager').then(mod => ({
    default: mod.HelpCenterChatbot,
  })),
);
